import React, { Component } from 'react';
import { Switch, Route, Redirect, BrowserRouter as Router } from "react-router-dom";
import { createHashHistory } from 'history';
import HomeRoute from "../../Home/Routes/HomeRoute";
import ChatRoute from '../Modules/ChatHistory/Routes/ChatRoute';
import ContactManagementRoute from '../../ContactManagement/Routes/ContactManagementRoute';
import AccountRoute from '../../Account/Routes/AccountRoute';
class index extends Component {
  render() {
    const history = createHashHistory();
    return (
      <>
        <Switch>
          <Route exact path="/" component={HomeRoute} />
          <Route exact path="/:lng/home" component={HomeRoute} />
          <Route exact path="/:lng/contact_management" component={ContactManagementRoute} />
          <Route exact path="/:lng/account" component={AccountRoute} />
        </Switch>

      </>
    );
  }
}
export default index;
